import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PortalVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.post(`${API}/resident/auth/magic`, { token: params.get("token") || "" }, { withCredentials: true });
        navigate(data.has_password ? "/portal" : "/portal/account?setup=1");
      } catch (e) {
        setError(e.response?.data?.detail || "This link didn't work — request a new one.");
      }
    })();
  }, [navigate, params]);

  return (
    <div className="min-h-screen bg-[#1a1614] flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl p-8 max-w-sm w-full text-center" data-testid="portal-verify">
        {error
          ? (<><div className="font-heading font-bold text-lg text-ink">Link expired</div>
              <p className="text-sm text-ink/60 mt-2">{error}</p>
              <button onClick={() => navigate("/portal/login")} className="mt-5 rounded-full bg-redline-500 text-white font-bold px-6 py-3 text-sm">Back to sign in</button></>)
          : (<><div className="h-7 w-7 rounded-full border-2 border-redline-500 border-t-transparent animate-spin mx-auto" />
              <p className="text-sm text-ink/60 mt-4">Signing you in…</p></>)}
      </div>
    </div>
  );
}
